//Dependecies
import React from 'react'

//Components
import AppHeader from '../../../global_components/app_header/AppHeader'
import ContentContainer from './ContentContainer'

const DashboardContainer = () => {
  return (
    <div className='h-full w-full'>
      <AppHeader />
      <ContentContainer />
    </div>
  )
}

export default DashboardContainer